import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription} from 'rxjs/Rx';
import { LocalStorage } from 'ngx-store';

//Model
import { TaskNotification } from './tasknotifications.model';
import { User } from '../../model/users.model';
import { Url } from '../../model/users.model';

//Service
import { TaskNotificationsService } from './tasknotifications.service';
import { ComponentsSettingsService } from 'src/app/services/components_settings.service';

@Component({
  selector: 'app-tasknotifications',
  templateUrl: './tasknotifications.component.html',
  styleUrls: ['./tasknotifications.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ TaskNotificationsService ]
})
export class TasknotificationsComponent implements OnInit {

  @LocalStorage() url: Url;
  @LocalStorage() user: User;

  public tasknotifications: TaskNotification[];
  public notificationCount: number;
  public rawtasknotifications: TaskNotification[];
  folderPath: string;

  task_subscriber : Subscription;

  constructor(private taskNotificationService: TaskNotificationsService, private svc_components : ComponentsSettingsService,
    private router: Router) {
    this.notificationCount = 0;
    this.getTaskNotifications();
    
    //every 10 min.
    const task_observable = Observable.interval(10000 * 60);
		this.task_subscriber = task_observable.subscribe(x => {
			this.getTaskNotifications();
		});
  }

  ngOnInit() {
    this.folderPath = this.url.fileStorage + '/users';
  }

  ngOnDestroy() {
		this.task_subscriber.unsubscribe();
	}

  public getTaskNotifications(){
    console.log('start task notification...')
    this.taskNotificationService.getTaskNotifications(this.user.id).subscribe(notifications =>{
      this.tasknotifications = notifications["notifications"];
      this.rawtasknotifications = this.tasknotifications;
      
      this.notificationCount = notifications["count"][0].taskCount;

    })
  }

  public navigateTaskList(){
    if (this.isEnabled('Tasks')) {
      this.router.navigate(['tasks']);
    }
  }

  public updateTaskViewed(){

    // will only update if there is new unviewed task record for the user.
    if(this.notificationCount > 0)
    {
      let d = new Date();
      let dateViewed = d.toString().substring(4, 24) ; 
      
      //sets the viewed_at field for viewed notification.
      this.rawtasknotifications.forEach(data=>{
        if(data.viewed_at == '0000-00-00 00:00:00' || data.viewed_at == null){
          data.viewed_at = dateViewed.toString();};
          this.taskNotificationService.updateTaskNotifications(data).subscribe(data=>{
          console.log('viewed data was updated...')
          });
      });
    }   
    
  }

  isEnabled(name){
    let is_enabled = false;
    is_enabled = this.svc_components.isComponentEnabled(name);
    return is_enabled
  }
}
